import {ITooltip} from '../../../1elements'
import IconButton from '@mui/material/IconButton'
import SetDefault from '../../../1elements/Icons/js/SetDefault'


const SetToDefaultButton = ({onClick, className}) => {

    return (
        <div className={className}>
            <ITooltip content={'Set to default'} placement={'top'} >
                <IconButton onClick={onClick}>
                    <SetDefault />
                </IconButton>
            </ITooltip>
        </div>
    )
}

export default SetToDefaultButton